import { BaseModel } from './base';

export enum EShopItemLicenseType {
    LEGACY = 'legacy',
    PERSONAL = 'personal',
    COMMERCIAL = 'commercial'
}

export enum EShopItemBillingPeriod {
    LEGACY = 'legacy',
    MONTHLY = 'monthly',
    ANNUAL = 'annual'
}

export const SHOP_ITEM_IDS = {
    LEGACY_PRO_30_DAY: 'BHNy4cogfY',
    LEGACY_PRO_60_DAY: 'W8aFnVoaPw',
    LEGACY_PRO_90_DAY: 'TF9RMK7g4O',
    PERSONAL_PLUS_30_DAY: 'Pers30Plus',
    PERSONAL_PLUS_365_DAY: 'Pers365Pls',
    COMMERCIAL_CREATOR_30_DAY: 'Comm30Crtr',
    COMMERCIAL_CREATOR_365_DAY: 'Comm365Crt'
} as const;

export class ShopItem extends BaseModel {
    public static PARSE_CLASSNAME = 'ShopItem';
    private _description: string;
    private _price: number;
    private _days: number;
    private _active: boolean;
    private _licenseType: EShopItemLicenseType;
    private _billingPeriod: EShopItemBillingPeriod;
    private _giftable: boolean;

    constructor() {
        super(ShopItem.PARSE_CLASSNAME);
    }


    /**
     * Getter description
     * @return {string}
     */
    public get description(): string {
        return this._description;
    }

    /**
     * Getter price
     * @return {number}
     */
    public get price(): number {
        return this._price;
    }

    /**
     * Getter days
     * @return {number}
     */
    public get days(): number {
        return this._days;
    }

    /**
     * Getter active
     * @return {boolean}
     */
    public get active(): boolean {
        return this._active;
    }

    public get licenseType(): EShopItemLicenseType {
        return this._licenseType;
    }

    public get billingPeriod(): EShopItemBillingPeriod {
        return this._billingPeriod;
    }

    public get giftable(): boolean {
        return this._giftable;
    }

    public grantsCommercialUse(): boolean {
        return this.licenseType === EShopItemLicenseType.COMMERCIAL ||
            this.licenseType === EShopItemLicenseType.LEGACY;
    }

    /**
     * Setter description
     * @param {string} value
     */
    public set description(value: string) {
        this._description = value;
    }

    /**
     * Setter price
     * @param {number} value
     */
    public set price(value: number) {
        this._price = value;
    }

    /**
     * Setter days
     * @param {number} value
     */
    public set days(value: number) {
        this._days = value;
    }

    /**
     * Setter active
     * @param {boolean} value
     */
    public set active(value: boolean) {
        this._active = value;
    }

    public set licenseType(value: EShopItemLicenseType) {
        this._licenseType = value;
    }

    public set billingPeriod(value: EShopItemBillingPeriod) {
        this._billingPeriod = value;
    }

    public set giftable(value: boolean) {
        this._giftable = value;
    }

}

BaseModel.registerClass(ShopItem, ShopItem.PARSE_CLASSNAME);
